import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/config";
import { HTTP_STATUS } from "../../../app/constants";

const namespace = "salesreport";

const initialState = {
  loading: null,
  salesReportDetailsList: [],
  errorMessage: "",
};

//GET
export const getSalesDetailsforSalesReportFromServer = createAsyncThunk(
  `${namespace}/getSalesDetailsforSalesReportFromServer`,
  async (record, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/salesdetailsforsalesreport?customercode=${record.customerCode}&fromdate=${record.selectedFromDate}&todate=${record.selectedToDate}`,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return err.response.data;
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getSalesDetailsforSalesReportThermalPrintFromServer =
  createAsyncThunk(
    `${namespace}/getSalesDetailsforSalesReportThermalPrintFromServer`,
    async (record, { rejectWithValue }) => {
      try {
        const response = await api.get(
          `/thermalprintsalesdetailsforsalesreport?customercode=${record.customerCode}&fromdate=${record.selectedFromDate}&todate=${record.selectedToDate}`,
          {
            headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
          }
        );
        return response.data;
      } catch (err) {
        if (err.response) {
          return err.response.data;
        } else {
          return rejectWithValue({
            message: "Network error or server not reachable",
          });
        }
      }
    }
  );

export const salesReportSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSalesDetailsforSalesReportFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(
        getSalesDetailsforSalesReportFromServer.fulfilled,
        (state, action) => {
          state.loading = HTTP_STATUS.FULFILLED;
          state.salesReportDetailsList = action.payload.data;
          state.errorMessage = null;
        }
      )
      .addCase(
        getSalesDetailsforSalesReportFromServer.rejected,
        (state, { error }) => {
          state.loading = HTTP_STATUS.REJECTED;
          state.errorMessage = error.errorMessage;
        }
      )
      .addCase(
        getSalesDetailsforSalesReportThermalPrintFromServer.pending,
        (state) => {
          state.loading = HTTP_STATUS.PENDING;
        }
      )
      .addCase(
        getSalesDetailsforSalesReportThermalPrintFromServer.fulfilled,
        (state, action) => {
          state.loading = HTTP_STATUS.FULFILLED;
          state.errorMessage = null;
        }
      )
      .addCase(
        getSalesDetailsforSalesReportThermalPrintFromServer.rejected,
        (state, { error }) => {
          state.loading = HTTP_STATUS.REJECTED;
          state.errorMessage = error.errorMessage;
        }
      );
  },
});

export const selectAllSalesDetails = (state) =>
  state.salesreport.salesReportDetailsList;
export const selectLoadingStatus = (state) => state.salesreport.loading;
export default salesReportSlice.reducer;
